import { Component, OnInit, OnDestroy } from '@angular/core';
import { PlanService } from '../shared/plan-data.service';
import { FeatureData, Plan } from '../shared/models/plan.model';
import { PlanSelectionComponentButton } from './plan-selection-button/plan-selection-button.component';
import { DirectSessionLogicService } from '../shared/direct-session-logic.service';
import { ActivatedRoute } from '@angular/router';
import { ConfigData } from '../shared/models/config-data.model';
import { PromoService } from '../shared/promo.service';
import { DirectApiService } from '../shared/directApi.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-plan-selection',
    template:`
        @if(customPlansPage){
            <div class="card p-4 mt-4 mb-4 mx-4" style="border-radius: 16px;">
                <div class="main-page-container" >
                    <h2 class="text-center">Choose a plan</h2>
                    <p class="lead text-center">
                        All plans come with $1 million insurance and 24/7 customer support.
                    </p>
                    <p class="lead text-center">
                        If you have questions please call us at <a href="tel:{{callNumber}}">{{displayedPhoneNumber}}</a>
                    </p>
                    <div class="row">
                        @for(plan of FilteredPlans; track plan.urlExtension){
                            <div class="col-md-4 col-sm-12" >
                                <app-plan-selection-button [plan]="plan" [featuresTotal]="Features"></app-plan-selection-button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        @if(!customPlansPage){
            <div class="card p-4 mt-4 mb-4 mx-4" style="border-radius: 16px;">
                <div class="main-page-container" >
                    <h2 class="text-center">Loading Plans data, please wait...</h2>
                    <p class="lead text-center">
                        If you have any issues please call us at <a href="tel:{{callNumber}}">{{displayedPhoneNumber}}</a>
                    </p>
    
                    <div class="alt-spinner">
                        <mat-spinner diameter="170" class="mat-mdc-progress-spinner"></mat-spinner>
                    </div>
                </div>
            </div>
        }
        
    `,
    styleUrls: ['./plan-selection.component.scss'],
    standalone: true,
    imports: [ 
        PlanSelectionComponentButton,
        MatProgressSpinner
     ],
  })
export class PlanSelectionComponent implements OnInit, OnDestroy {

    FilteredPlans: Plan[] = [];
    configData: ConfigData = {} as ConfigData;
    displayedPhoneNumber: string = "";
    callNumber: string = "";
    CompanyId: number = 0;
    
    customPlansPage = false;

    private planSubsc: Subscription;
    private promoSubsc: Subscription;

    constructor(
        private readonly route: ActivatedRoute,
        public planService: PlanService,
        public directSessionLogic: DirectSessionLogicService,
        public directAPI: DirectApiService,
        public promoService: PromoService,

    ) {
        this.configData = environment as ConfigData;
        this.CompanyId = environment.CompanyInfo.CompanyId;

        let sFeatures = this.planService.featureViewSignalValue; //trigger fetch if needed
        
        // .../plans/{planId goes here and checks against plans}
        this.planSubsc = this.route.params.subscribe(params => {
            const planId = params['planId'];
            if(planId != null){
                console.log("Plan selection page received planId from URL: ", planId);
                this.FilterPlansLogic(planId);
            }
        });

        //at end of plan selection url? pass along into session code, will check at cart sub-component.
        //   ...?promo=WELCOME10 
        this.promoSubsc = this.route.queryParams.subscribe(values => {
            const promo = values['promo'];
            if(promo != null ) {
                this.checkSetPromoCode(promo);
            };
        });

    };

    get Plans(): Plan[] {
        return this.planService.planViewSignal();
    }
    get Features(): FeatureData[] {
        return this.planService.featureViewSignal();
    }


    // async initConfig() {
    async ngOnInit() {
        this.displayedPhoneNumber = environment.CompanyInfo.DisplayedPhoneNumber;
        this.callNumber = "+"+ this.displayedPhoneNumber.replace(/\D/g,"");
        this.customPlansPage = environment.ConnectionInfo.generatePlansFromApi.toString() === 'true';
        
        await this.planService.getPlans();
        this.FilterPlansLogic(null); //this.FilteredPlans = this.Plans;
        this.CompanyId = environment.CompanyInfo.CompanyId;
    }
    
    async FilterPlansLogic(planId: string | null) {

        if (planId) {
            
            console.log("PlanId: ", planId);
            if(planId[0]=="$"){
                //if we see a $ only show the targeted site plans
                console.log("Detected All plans request");
                this.FilteredPlans = this.Plans.filter(plan => plan.displayOnTargeted === true);
            }else{
                this.planService.SetPlanSelectionFromUrl(planId);

                console.log("selecting Plan", planId);

                if(this.Plans.length == 0){
                    await this.planService.getPlans();
                }

                //may need to re-grab allPlans from signal after fetch
                let allPlans = this.planService.planViewSignal();
                const plan = allPlans.find(plan => plan.urlExtension === planId);
                if (plan == undefined) {
                    console.log("No plan found matching planId: ", planId);
                }else{
                    // console.log("Plan selected from URL: ", plan);
                    this.directSessionLogic.setCustomerPlan(plan);
                }
            }
        }else{
            this.DefaultPlanFiltering();
        }
    }
    async DefaultPlanFiltering(){
        //if no plan id is provided, only show the direct site plans
        let allPlans = this.Plans;
        if(allPlans.length == 0){
            await this.planService.getPlans();
        }
        this.FilteredPlans = allPlans.filter(plan => plan.displayOnDirectSite === true);
    }

    async checkSetPromoCode(promo: string) {
        console.log("Checking promo code from URL in plan selection: ", promo);

        if(promo.length > 0 && promo != undefined ){
            let planUrlId = this.directSessionLogic.selectedPlanSignalValue?.urlExtension;

            this.promoService.updateCouponInputSignal(promo.toUpperCase());
            if(planUrlId != undefined && planUrlId.length > 0){
                let plan = this.directSessionLogic.planSelectedSignal();
                await this.promoService.validateCouponInputSignal(plan);
                this.directSessionLogic.recalculateTotalCostInSessionSignal();
            }
        }
    }


    ngOnDestroy() {
        this.planSubsc?.unsubscribe();
        this.promoSubsc?.unsubscribe();
    }
}